import {
  Banner,
  BannerButton,
  BannerDescription,
  BannerTitle,
} from "@prismicio/editor-ui"
import { useLayoutEffect } from "react"
import { Link } from "react-router-dom"

import { useSubscriptionQuery } from "../../settings/billing/useSubscription"
import { pricingUrl } from "../constants"
import { getCurrentMonthYear } from "./getCurrentMonthYear"
import { useGlobalBanner } from "./GlobalBanner"

export function useAutoUpgradedBanner() {
  const { showBanner } = useGlobalBanner()

  const { data: subscription } = useSubscriptionQuery()

  useLayoutEffect(() => {
    if (subscription.wasAutoUpgradedRecently) {
      showBanner({
        id: `auto-upgraded-${subscription.id}-${getCurrentMonthYear()}`,
        render: ({ onClose }) => (
          <AutoUpgradedBanner
            planNickname={subscription.nickname}
            onClose={onClose}
          />
        ),
      })
    }
  }, [subscription, showBanner])
}

interface AutoUpgradedBannerProps {
  planNickname: string
  onClose: () => void
}

function AutoUpgradedBanner(props: AutoUpgradedBannerProps) {
  const { planNickname, onClose } = props

  return (
    <Banner color="warn" iconName="alert" onClose={onClose}>
      <BannerTitle>You've been upgraded!</BannerTitle>
      <BannerDescription>
        Your plan has been automatically upgraded to support your growing usage.
        Enjoy the benefits of your new {planNickname} plan.
      </BannerDescription>
      <BannerButton asChild>
        <Link to={pricingUrl}>Explore →</Link>
      </BannerButton>
    </Banner>
  )
}
